(ns cljsjs.react-draggable
  (:require ["react-draggable" :as react-draggable]))

;;npm install react-draggable(?)
(js/goog.exportSymbol "ReactDraggable" react-draggable)
